import { render, staticRenderFns } from "./DashboardTable.vue?vue&type=template&id=1369febe&scoped=true&"
import script from "./DashboardTable.vue?vue&type=script&lang=js&"
export * from "./DashboardTable.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTable.vue?vue&type=style&index=0&id=1369febe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1369febe",
  null
  
)

export default component.exports